import { makeSelectors } from '@utils/css';
import { toolbarCls } from './molecule.toolbar.style.js';

const POSTLOADED_TRANSITION_DURATION_MS = 375;
const wrapper = "_uw7w10hck7v";
const container = "_uw7c1x2feb5";
const throbber = "_uw7tp93385";
const content = "_uw7cw4h8l3";
const pm2ModalSelectors = makeSelectors({
  container,
  content,
  toolbar: toolbarCls
});

export { POSTLOADED_TRANSITION_DURATION_MS, container, content, pm2ModalSelectors, throbber, wrapper };
import "./organism.content.style.linaria.module.css";
//# sourceMappingURL=organism.content.style.js.map
